// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"91a583a9","807":"b5125141"}[chunkId] + ".chunk.css";
};